import { BuyerOptionProps } from '.';

import GenericText from './GenericText';


export default function Text(props: BuyerOptionProps) {
  return <GenericText textFieldMaxLength={255} {...props} />;
}
